module.exports = __webpack_public_path__ + "img/20180120_4.ee862526.jpeg";